import { METHOD, requestSet } from "@/utils/request";

export async function apiRequest(method, path, params) {
    return requestSet(path, method.toUpperCase() === 'GET' ? METHOD.GET : METHOD.POST, params, {});
}

export async function apiHiddenAiUrl(params) {
    return requestSet("/external/agent/hiddenAiUrl", METHOD.GET, params, {});
}
